module.exports = __webpack_public_path__ + "static/media/smartphoneIcon.37beda9d.png";